module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.26.0@babel-runtime/regenerator/index.js
// module id = 27
// module chunks = 69